import React from "react";
import { Text, Box, VStack, HStack, Badge } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

interface EvidenceCard {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  matchPercentage: number;
}

const LawTab: React.FC = () => {
  const { t } = useTranslation("common");

  // Static data - will be replaced with API data later
  const lawCards: EvidenceCard[] = [
    {
      id: "1",
      title: "OSHA-1910.212",
      subtitle: "General requirements for all machines",
      description:
        "One or more methods of machine guarding shall be provided to protect the operator and other employees in the machine area from hazards such as those created by point of operation, ingoing nip points, rotating parts, flying chips and sparks.",
      matchPercentage: 95,
    },
    {
      id: "2",
      title: "OSHA-1910.212",
      subtitle: "General requirements for all machines",
      description:
        "One or more methods of machine guarding shall be provided to protect the operator and other employees in the machine area from hazards such as those created by point of operation, ingoing nip points, rotating parts, flying chips and sparks.",
      matchPercentage: 95,
    },
    {
      id: "3",
      title: "OSHA-1910.212",
      subtitle: "General requirements for all machines",
      description:
        "One or more methods of machine guarding shall be provided to protect the operator and other employees in the machine area from hazards such as those created by point of operation, ingoing nip points, rotating parts, flying chips and sparks.",
      matchPercentage: 95,
    },
  ];

  return (
    <VStack spacing={4} align="stretch">
      {lawCards?.map((card) => (
        <Box
          key={card.id}
          bg="white"
          border="1px solid"
          borderColor="gray.200"
          borderRadius="8px"
          p={4}
          position="relative"
        >
          <HStack justify="space-between" align="start" mb={2}>
            <VStack align="start" spacing={1}>
              <Text fontSize="16px" fontWeight="700" color="#1A202C">
                {card?.title}
              </Text>
              <Text fontSize="14px" color="#6B7280">
                {card?.subtitle}
              </Text>
            </VStack>
            <Badge
              bg="transparent"
              color="#005EB8"
              border="1px solid #005EB8"
              borderRadius="4px"
              px={2}
              py={1}
              fontSize="12px"
              fontWeight="500"
            >
              {t("evidenceReview.matchPercentage", {
                percentage: card?.matchPercentage,
              })}
            </Badge>
          </HStack>
          <Text fontSize="14px" color="#374151" lineHeight="1.5">
            {card?.description}
          </Text>
        </Box>
      ))}
    </VStack>
  );
};

export default LawTab;
